import React from 'react';
import {Dialog} from "primereact/dialog";
import getLabel from '../../services/LinkagesDataLayer/labels';
import LinkagesDataLayerService from "../../services/LinkagesDataLayer/LinkagesDataLayerService";
import './estilos.css';
import {Column} from "primereact/column";
import { DataTable } from 'primereact/datatable';

const propertiesDictionatary = {
    'trabalhador' : [
        'ano',
        'agricultura',
        'taxa_agricultura',
        'industrias_extrativas',
        'taxa_industrias_extrativas',
        'industrias_transformacao',
        'taxa_industrias_transformacao',
        'eletricidade_gas',
        'taxa_eletrecidade_gas',
        'agua_esgoto_residuos',
        'taxa_agua_esgoto_residuos',
        'construcao',
        'taxa_construcao',
        'comercio_veiculos',
        'taxa_comercio_veiculos',
        'transporte_armazenagem',
        'taxa_transporte_armazenagem',
        'alojamento_alimentacao',
        'taxa_alojamento_alimentacao',
        'informacao_comunicacao',
        'taxa_informacao_comunicacao',
        'atividades_financeiras',
        'taxa_atividades_financeiras',
        'atividades_imobiliarias',
        'taxa_atividades_imobiliarias',
        'atividades_profissionais_cien_tec',
        'taxa_atividades_profissionais_cien_tec',
        'atividades_administrativas',
        'taxa_atividades_administrativas',
        'administracao_publica',
        'taxa_administracao_publica',
        'educacao',
        'taxa_educacao',
        'saude_servicos_sociais',
        'taxa_saude_servicos_sociais',
        'artes_recreacao',
        'taxa_artes_recreacao',
        'outros',
        'taxa_outros',
        'servicos_domesticos',
        'taxa_servicos_domesticos',
        'org_internacionais',
        'taxa_org_internacionais',
        'total',
    ],
    'expansao_urbana' : [
        'ano',
        'area',
        'crescimento_percentual',
        'area_total_km2',
        'sigla_uf',
    ],
    'area_urbanizada': [
        'ano',
        'area_total_km2',
    ],
    'dutovias': [
        'fonte',
        'nome_dutovia',
        'categoria',
        'distribuidora',
        'tipo_dutovia',
    ],
    'vazios_urbanos': [
        'nm_municipio',
        'area_km2',
    ],
    'area_preservacao': [
        'tipo',
        'nome',
    ]

};

class LinkagesDataDictionaryModal extends React.Component {

    /**
     * O dicionário de dados deve mostrar Consumo como um único grupo,
     * embora internamente a camada do mapa ainda distinga 'consumo_valor'
     * (R$) de 'consumo_porcentagem' (%). Aqui as duas entradas viram uma
     * só ('consumo'), só para exibição nesse modal.
     */
    static mergeConsumoOptions = (groups) => {
        return groups.map(group => {
            if (!group.options.some(o => o.value === 'consumo_valor' || o.value === 'consumo_porcentagem')) {
                return group;
            }

            const options = [];
            let consumoInserted = false;

            group.options.forEach(o => {
                if (o.value === 'consumo_valor' || o.value === 'consumo_porcentagem') {
                    if (!consumoInserted) {
                        options.push({ value: 'consumo', label: 'Consumo' });
                        consumoInserted = true;
                    }
                    return;
                }
                options.push(o);
            });

            return { ...group, options };
        });
    }

    constructor(props) {
        super(props);
        const options = LinkagesDataDictionaryModal.mergeConsumoOptions(LinkagesDataLayerService.getAvailableLayers());
        let activeDataLayer = 'renda';
        let properties = [];

        if( props.activeDatalayer ){
            activeDataLayer = props.activeDatalayer;
        }

        if( activeDataLayer === 'consumo_valor' || activeDataLayer === 'consumo_porcentagem' ){
            activeDataLayer = 'consumo';
        }

        this.state = {
            dictionary: [],
            options: options,
            activeDatalayer: activeDataLayer,
            properties: properties
        }
    }

    componentDidMount = async () => {
        await this.loadDictionary();
    }

    loadDictionary = async () => {
        try {
            const response = await LinkagesDataLayerService.getDataDictionary();
            if (response && response.data) {
                this.setState({dictionary: response.data});
            }
        } catch (error) {
            console.error(error);
        }
    }

    getProperties = (option) => {
        let properties = option === 'consumo'
            ? [
                ...(LinkagesDataLayerService.getPropertiesForColorMap('consumo_valor') || []),
                ...(LinkagesDataLayerService.getPropertiesForColorMap('consumo_porcentagem') || []),
            ]
            : LinkagesDataLayerService.getPropertiesForColorMap(option);

        let specialCases = ['trabalhador', 'expansao_urbana', 'area_urbanizada', 'vazios_urbanos', 'dutovias', 'area_preservacao'];


        if( specialCases.includes(option) ){
            properties = propertiesDictionatary[option];
        }

        if( properties && properties.length > 0 ){
            properties = properties?.map(prop => {
                let property = prop;
                if( prop.includes("|")){
                    property = prop.split('|')[1];
                }
                /**
                 * {
                 *         "tema": "zoneamento",
                 *         "nome_no_banco": "sigla_zoneamento",
                 *         "descricao": "sigla do zoneamento"
                 *     },
                 */
                let descricao = this.state.dictionary.find( item => item.nome_no_banco === property );

                return {
                    label: getLabel(property),
                    value: property,
                    description: descricao ? descricao.descricao : '',
                };
            })
        }

        if( option === 'consumo' && properties && properties.length > 0 ){
            properties = LinkagesDataDictionaryModal.dedupeConsumoProperties(properties);
        }

        return properties;
    }

    /**
     * Cada variável de Consumo existe no banco em 3 colunas (tx_/vl_/total_),
     * uma pra percentual, uma pra média mensal e uma pra total anual — mas a
     * descrição é a mesma nas 3 e já explica isso. Aqui elas viram uma única
     * linha por variável, sem o sufixo "(%)"/"(R$)" do rótulo.
     */
    static PREFIX_PRIORITY = { vl_: 0, tx_: 1, total_: 2 };

    // Ordem exata pedida pelo cliente (tabela do SUP-444), por baseKey (nome_no_banco sem prefixo tx_/vl_/total_)
    static CONSUMO_ORDER = [
        'despesas_consumo',
        'alimentacao_fora',
        'alimentacao_dentro',
        'habitacao',
        'educacao',
        'saude',
        'recreacao_e_cultura',
        'investimento_em_imovel',
        'alimentacao_bebidas',
        'material_construcao',
        'artigos_limpeza',
        'mobiliarios_artigos_lar',
        'eletrodomesticos',
        'vestuario',
        'calcados',
        'despesas_viagens',
        'higiene_cuidados_pessoais',
        'matriculas_mensalidades',
        'livros_material_escolar',
        'gastos_medicamentos',
        'outras_despesas_saude',
        'acessorios_de_moda',
        'servicos_pessoais',
    ];

    static dedupeConsumoProperties = (properties) => {
        const bestByKey = new Map();

        properties.forEach(prop => {
            const prefixMatch = prop.value.match(/^(tx_|vl_|total_)/);
            const prefix = prefixMatch ? prefixMatch[1] : '';
            const baseKey = prop.value.replace(/^(tx_|vl_|total_)/, '');
            const priority = LinkagesDataDictionaryModal.PREFIX_PRIORITY[prefix] ?? 99;

            const current = bestByKey.get(baseKey);
            if (!current || priority < current.priority) {
                bestByKey.set(baseKey, { baseKey, prop, priority });
            }
        });

        const order = LinkagesDataDictionaryModal.CONSUMO_ORDER;

        const result = Array.from(bestByKey.values())
            .sort((a, b) => {
                const indexA = order.indexOf(a.baseKey);
                const indexB = order.indexOf(b.baseKey);
                if (indexA === -1 && indexB === -1) return 0;
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;
                return indexA - indexB;
            })
            .map(({ prop }) => ({
                ...prop,
                label: prop.label.replace(/\s*\((%|R\$)\)\s*$/i, ''),
            }));

        return result;
    }

    handleChangeDatalayer = async (option) => {
        this.setState({
            ...this.state,
            activeDatalayer: option,
        });
    }

    render() {

        let properties = this.getProperties(this.state.activeDatalayer);

        return (<React.Fragment>
            <Dialog header="Dicionário de dados" visible={this.props.visible}
                    style={{width: '70vw', marginTop: '30px'}} onHide={this.props.onHide}>
                <div className="card" id="data-dictionary-container" style={{
                    maxHeight: '75vh',
                    minHeight: '50vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    marginBottom: '20px'
                }}>
                    <div className="card-body" style={{overflowX: 'scroll'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-3">
                                    <ul className="list-unstyled">
                                        {this.state.options.map( option => {
                                            return (
                                                <li key={option.group}>
                                                    <span className="font-weight-bold">
                                                        {option.group}
                                                    </span>
                                                    <ul className="list-unstyled" style={{
                                                        marginLeft: '20px',
                                                    }}>
                                                        {option.options.map( o => {
                                                            return (
                                                                <li key={o.value} className="">
                                                                    <a onClick={async (e)=>{
                                                                        e.preventDefault();
                                                                        await this.handleChangeDatalayer(o.value);
                                                                    }}
                                                                       className="btn-link btn-link-seletor"
                                                                       href="#" >
                                                                        {o.label}
                                                                    </a>
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                                <div className="col-9">
                                    <div className="card">
                                        <h5>{this.props.datalayerName}</h5>
                                        <DataTable value={properties} scrollable scrollHeight="500px">
                                            <Column field="label" header="Variável"></Column>
                                            <Column field="description" header="Descrição"></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>);
    }
}

LinkagesDataDictionaryModal.defaultProps = {
    visible: false,
    data: [],
    columns: [],
    datalayerLabel: 'Datalayer',
    onHide: () => {
    }
}


export default LinkagesDataDictionaryModal;
